import { makeStyles } from "@material-ui/core";
import React from "react";


 
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 15px",
    margin: "20px",
    textAlign: "center",
    // marginBottom: "15px",
    backgroundColor: "white",
    boxShadow: "0px 0px 19px -2px rgba(163, 163, 163, 0.3)",
    border: "1px solid #ddd",
    borderRadius: "3px",
  },
}));

export const NotificationListEmpty: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <h2>No Notifications</h2>
      <p>Try adjusting the filter above to see more notifications.</p>
    </div>
  );
};
